import { Injectable } from '@angular/core';

// Redux
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../core/store/store';

// Core
import { ErrorMessage } from '../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../core/interfaces/bool-result';
import { IObjectResult } from '../../core/interfaces/object-result';

// Config
import { appConfig } from '../../config/app-config';

// Own feature
import { Mangel } from '../model/mangel';
import { mangelConfig } from '../config/mangel.config';
import { MaengelDatahubService } from '../service/maengel-datahub.service';
import {
   // own feature
   mangelAddItem,
   mangelEdidItem,
   mangelDeleteItem,
   mangelSelectStock,
   mangelResetStateAll,
   mangelStoreStockObjects,
   mangelStoreDetailJss
} from '../store/actions';


@Injectable()
export class MaengelService {

   constructor(
      private _store: NgRedux<IAppState>,
      private _dataHub: MaengelDatahubService
   ) { }

   // --------------------------------------------------------------------------------------------
   // -- public Mangel functions -----------------------------------------------------------------
   // --------------------------------------------------------------------------------------------
   public resetMaengelAllState(
   ): void {
      if (mangelConfig.debugMode) {console.log('[MaengelService]:resetMaengelAllState(called)'); }

      // store
      this._store.dispatch(mangelResetStateAll());
   }

   public saveMaengelDetail(
      mangel: any
   ): Promise<IBoolResult> {
      if (mangelConfig.debugMode) {console.log('[MaengelService]:saveMaengelDetail(called)'); }

      // -->> ASY1
      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // passs to data hub
         this._dataHub.saveMaengelDetail(
            mangel,
            mangelConfig.debugMode
         )
         .then(() => {
            this.loadMaengelListe();
            // optimistic/pessimistic storage
            // if (mangelConfig.dbPessimisticUpdate) {
            //    this.loadMaengelListe();
            // } else {
            //    this._store.dispatch(mangelEdidItem(mangel));
            // }
         })
         .catch((err: ErrorMessage) => { reject(err); });
      });
      return prom;
   }

   public loadMaengelListe(): Promise<IBoolResult> {
      if (mangelConfig.debugMode) {console.log('[MaengelService]:loadMaengelListe(called)'); }

      // sync check

      // -->> ASY1
      const prom = new Promise<IBoolResult>((resolve, reject) => {
         const result: Mangel[] = [];
         this._dataHub.loadMaengelListe(
            result,
            mangelConfig.debugMode
         )
         .then( (boolResultASY1: IBoolResult) => {

            // evaluate result
            if (boolResultASY1.result) {
               // store
               this._store.dispatch(mangelStoreStockObjects(result));
            } else {
               console.log('[MaengelService] Keine Maengel vorhanden');
               this._store.dispatch(mangelStoreStockObjects(null));
            }

            // ASY1 -->> send
            resolve(boolResultASY1);
         })
         .catch( (err: ErrorMessage) => {
            console.warn(err);
            this._store.dispatch(mangelResetStateAll());
            reject(err);
         });
      });
      return prom;
   }

   public loadMaengelDetail(
      id: string
   ): Promise<IBoolResult> {
      if (mangelConfig.debugMode) {console.log('[MaengelService]:loadMaengelDetail(called)'); }

      // sync check

      // async
      const prom = new Promise<IBoolResult>((resolve, reject) => {

         // -->> ASY1
         this._dataHub.loadMaengelDetailJss(
            mangelConfig.debugMode
         )
         .then( (fs: any) => {

            // evaluate result
            if (fs) {
               // store
               this._store.dispatch(mangelStoreDetailJss(fs));
               // ASY1 -->> send
               resolve(BoolResult.createBoolResult_true());
               return;
            }

            // fs === null -->> send
            reject(BoolResult.createBoolResult2_false('maengel/NO_DATA', 'Keine Daten vorhanden'));
         })
         .catch( (err: ErrorMessage) => {
            console.warn(err);
            this._store.dispatch(mangelResetStateAll());
            reject(err);
         });
      });
      return prom;
   }

   public resetMaengelDetail(
   ): void {
      if (mangelConfig.debugMode) {console.log('[MaengelService]:resetMaengelDetail(called)'); }

      // store
      this._store.dispatch(mangelStoreDetailJss(null));
   }

   // --------------------------------------------------------------------------------------------
   // -- private Mangel functions ----------------------------------------------------------------
   // --------------------------------------------------------------------------------------------

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/service/maengel.service.ts